import React from 'react'

import Header from './components/header/Header.jsx'
import Nav from './components/nav/Nav.jsx'
import About from './components/about/About.jsx'
import Experience from './components/experience/Experience.jsx'
import Portfolio from './components/portfolio/Portfolio.jsx'
import Contact from './components/contact/Contact.jsx'
import Footer from './components/footer/Footer.jsx'

/*===== NOT IN USE =====*/

import Services from './components/services/Services.jsx'
import Testimonials from './components/testimonials/Testimonials.jsx'

const App = () => {
  return (
    <>
    <Header/>
    <Nav/>
    <About/>
    <Experience/>
    {/*<Services/>*/}
    <Portfolio/>
    {/*<Testimonials/>*/}
    <Contact/>
    <Footer/>
    </>
  )
}

export default App